import { render } from "./ListeDureeMedicament.vue?vue&type=template&id=a484d56c&scoped=true"
import script from "./ListeDureeMedicament.vue?vue&type=script&lang=js"
export * from "./ListeDureeMedicament.vue?vue&type=script&lang=js"

import "./ListeDureeMedicament.vue?vue&type=style&index=0&id=a484d56c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a484d56c"]])

export default __exports__